import { render, staticRenderFns } from "./CalendarWidget.vue?vue&type=template&id=686e5b0a&"
import script from "./CalendarWidget.vue?vue&type=script&lang=js&"
export * from "./CalendarWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('686e5b0a')) {
      api.createRecord('686e5b0a', component.options)
    } else {
      api.reload('686e5b0a', component.options)
    }
    module.hot.accept("./CalendarWidget.vue?vue&type=template&id=686e5b0a&", function () {
      api.rerender('686e5b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configurations/Widgets/CalendarWidget.vue"
export default component.exports